export enum UserType {
  Agent = 'Agent',
  Driver = 'Driver',
  Manager = 'FleetManager',
  Broker = 'Broker',
  Anonymous = 'Anonymous',
  Unknown = 'Unknown', // This is not supported by the BE, used only to block FE flows
}
